export interface Message<S, A, D> {
  service: S;
  action: A;
  data: D;
}

export interface IncomingMessage<S, A, D> extends Message<S, A, D> {
  code: number;
  source: string;
  destination: string;
}

export type ErrorMessage = IncomingMessage<string, "error", { message: string; details: unknown }>;

export type InChannelLeave = IncomingMessage<"channel", "leave", { channel: string; connectionId: string }>;
export type InChannelJoin = IncomingMessage<"channel", "join", { channel: string; connectionId: string }>;

export type InChannelBroadcast = IncomingMessage<
  "channel",
  "broadcast",
  { channel: string; recipients: number }
>;

export type InChannelMessage<P> = IncomingMessage<
  "channel",
  "message",
  { channel: string; payload: P; event: string }
>;

export type InChannelMessages =
  InChannelLeave | InChannelJoin | InChannelBroadcast | InChannelMessage<unknown>;

export interface OutgoingMessage {
  appId: string;
}

export interface AuthenticatedOutgoingMessages {
  appId: string;
}

export type OutChannelBroadcast<T> = AuthenticatedOutgoingMessages & {
  service: "channel";
  action: "broadcast";
  appId: string;
  data: { channel: string; payload: T; event: string };
};
export type OutChannelJoin = OutgoingMessage & {
  service: "channel";
  action: "join";
  appId: string;
  token?: string;
  data: { channel: string };
};
export type OutChannelLeave = OutgoingMessage & {
  service: "channel";
  action: "leave";
  appId: string;
  data: { channel: string };
};

export type OutPing = {
  service: "root";
  action: "ping";
};

export type OutgoingMessages = OutChannelBroadcast<unknown> | OutChannelJoin | OutChannelLeave | OutPing;

export const isIncomingMessage = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  message: any,
): message is IncomingMessages => {
  return message.source !== undefined;
};

export type IncomingMessages =
  ErrorMessage | InChannelLeave | InChannelJoin | InChannelBroadcast | InChannelMessage<unknown>;
